import { ImporterSDK } from '@b2ag/module-importer-sdk'

import { IImporterRepository } from '../domain/IImporterRepository'

export default class ImporterRepository implements IImporterRepository {
  constructor(private readonly importerSDK: ImporterSDK) {}

  getDownloadUrl(correlationFileId: string): Promise<string> {
    return this.importerSDK.downloadFile(correlationFileId)
  }
}
